import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const UserManagementTab = () => {
  const [users, setUsers] = useState([
  {
    id: 1,
    username: 'ahmet.yilmaz',
    fullName: 'Ahmet Yılmaz',
    email: 'ahmet.yilmaz@callcenterpro.com.tr',
    role: 'agent',
    status: 'active',
    extension: '1001',
    department: 'Satış',
    lastLogin: '2025-11-07 14:30',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c85acdfd-1762273734161.png",
    avatarAlt: 'Professional headshot of Turkish man with short dark hair in business suit'
  },
  {
    id: 2,
    username: 'fatma.demir',
    fullName: 'Fatma Demir',
    email: 'fatma.demir@callcenterpro.com.tr',
    role: 'supervisor',
    status: 'active',
    extension: '2001',
    department: 'Müşteri Hizmetleri',
    lastLogin: '2025-11-07 15:15',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10fa48cea-1762248911257.png",
    avatarAlt: 'Professional headshot of Turkish woman with shoulder-length brown hair in business attire'
  },
  {
    id: 3,
    username: 'mehmet.ozkan',
    fullName: 'Mehmet Özkan',
    email: 'mehmet.ozkan@callcenterpro.com.tr',
    role: 'agent',
    status: 'inactive',
    extension: '1002',
    department: 'Teknik Destek',
    lastLogin: '2025-11-06 18:45',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d939f84f-1762249184406.png",
    avatarAlt: 'Professional headshot of Turkish man with beard and dark hair in casual business shirt'
  }]
  );

  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState('all');

  const [newUser, setNewUser] = useState({
    username: '',
    fullName: '',
    email: '',
    password: '',
    role: 'agent',
    extension: '',
    department: '',
    permissions: {
      makeOutboundCalls: true,
      receiveInboundCalls: true,
      transferCalls: false,
      accessReports: false,
      manageContacts: false,
      recordCalls: true
    }
  });

  const roleOptions = [
  { value: 'all', label: 'Tüm Roller' },
  { value: 'admin', label: 'Yönetici' },
  { value: 'supervisor', label: 'Süpervizör' },
  { value: 'agent', label: 'Temsilci' }];


  const departmentOptions = [
  { value: 'Satış', label: 'Satış' },
  { value: 'Müşteri Hizmetleri', label: 'Müşteri Hizmetleri' },
  { value: 'Teknik Destek', label: 'Teknik Destek' },
  { value: 'Pazarlama', label: 'Pazarlama' }];


  const filteredUsers = users?.filter((user) => {
    const matchesSearch = user?.fullName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    user?.username?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    user?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesRole = filterRole === 'all' || user?.role === filterRole;
    return matchesSearch && matchesRole;
  });

  const handleAddUser = () => {
    const user = {
      id: users?.length + 1,
      ...newUser,
      status: 'active',
      lastLogin: 'Hiç giriş yapmadı',
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10270550d-1762274265045.png",
      avatarAlt: 'Default avatar placeholder for new user account'
    };
    setUsers([...users, user]);
    setNewUser({
      username: '',
      fullName: '',
      email: '',
      password: '',
      role: 'agent',
      extension: '',
      department: '',
      permissions: {
        makeOutboundCalls: true,
        receiveInboundCalls: true,
        transferCalls: false,
        accessReports: false,
        manageContacts: false,
        recordCalls: true
      }
    });
    setShowAddUserModal(false);
  };

  const toggleUserStatus = (userId) => {
    setUsers(users?.map((user) =>
    user?.id === userId ?
    { ...user, status: user?.status === 'active' ? 'inactive' : 'active' } :
    user
    ));
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'admin':return 'bg-purple-100 text-purple-800';
      case 'supervisor':return 'bg-blue-100 text-blue-800';
      case 'agent':return 'bg-green-100 text-green-800';
      default:return 'bg-slate-100 text-slate-800';
    }
  };

  const getRoleLabel = (role) => {
    switch (role) {
      case 'admin':return 'Yönetici';
      case 'supervisor':return 'Süpervizör';
      case 'agent':return 'Temsilci';
      default:return role;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header Actions */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <Input
            type="search"
            placeholder="Kullanıcı ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full sm:w-80" />

          <Select
            options={roleOptions}
            value={filterRole}
            onChange={setFilterRole}
            placeholder="Rol filtrele" />

        </div>
        <Button
          variant="default"
          onClick={() => setShowAddUserModal(true)}
          iconName="UserPlus"
          iconPosition="left">

          Yeni Kullanıcı
        </Button>
      </div>
      {/* Users Table */}
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Kullanıcı</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Rol</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Dahili</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Departman</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Son Giriş</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">Durum</th>
                <th className="text-left py-3 px-4 font-medium text-slate-900">İşlemler</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {filteredUsers?.map((user) =>
              <tr key={user?.id} className="hover:bg-slate-50">
                  <td className="py-4 px-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-slate-200 rounded-full overflow-hidden flex-shrink-0">
                        <img
                        src={user?.avatar}
                        alt={user?.avatarAlt}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.src = '/assets/images/no_image.png';
                        }} />

                      </div>
                      <div>
                        <div className="font-medium text-slate-900">{user?.fullName}</div>
                        <div className="text-sm text-slate-600">{user?.email}</div>
                        <div className="text-xs text-slate-500">@{user?.username}</div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${getRoleColor(user?.role)}`}>
                      {getRoleLabel(user?.role)}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <span className="font-mono text-sm text-slate-900">{user?.extension}</span>
                  </td>
                  <td className="py-4 px-4">
                    <span className="text-sm text-slate-900">{user?.department}</span>
                  </td>
                  <td className="py-4 px-4">
                    <span className="text-sm text-slate-600">{user?.lastLogin}</span>
                  </td>
                  <td className="py-4 px-4">
                    <button
                    onClick={() => toggleUserStatus(user?.id)}
                    className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
                    user?.status === 'active' ? 'bg-success/10 text-success border border-success/20' : 'bg-error/10 text-error border border-error/20'}`
                    }>

                      <div className={`w-2 h-2 rounded-full mr-1 ${
                    user?.status === 'active' ? 'bg-success' : 'bg-error'}`
                    } />
                      {user?.status === 'active' ? 'Aktif' : 'Pasif'}
                    </button>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center space-x-2">
                      <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => setSelectedUser(user)}
                      iconName="Edit" />

                      <Button
                      variant="ghost"
                      size="sm"
                      iconName="Settings" />

                      <Button
                      variant="ghost"
                      size="sm"
                      iconName="Trash2" />

                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* Add User Modal */}
      {showAddUserModal &&
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-slate-900">Yeni Kullanıcı Ekle</h3>
                <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowAddUserModal(false)}
                iconName="X" />

              </div>
            </div>
            
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                label="Ad Soyad"
                type="text"
                value={newUser?.fullName}
                onChange={(e) => setNewUser({ ...newUser, fullName: e?.target?.value })}
                placeholder="Ahmet Yılmaz"
                required />

                <Input
                label="Kullanıcı Adı"
                type="text"
                value={newUser?.username}
                onChange={(e) => setNewUser({ ...newUser, username: e?.target?.value })}
                placeholder="ahmet.yilmaz"
                required />

                <Input
                label="E-posta"
                type="email"
                value={newUser?.email}
                onChange={(e) => setNewUser({ ...newUser, email: e?.target?.value })}
                placeholder="ahmet.yilmaz@example.com"
                required />

                <Input
                label="Şifre"
                type="password"
                value={newUser?.password}
                onChange={(e) => setNewUser({ ...newUser, password: e?.target?.value })}
                placeholder="Güçlü şifre"
                required />

                <Select
                label="Rol"
                options={roleOptions?.slice(1)}
                value={newUser?.role}
                onChange={(value) => setNewUser({ ...newUser, role: value })} />

                <Input
                label="Dahili Numara"
                type="text"
                value={newUser?.extension}
                onChange={(e) => setNewUser({ ...newUser, extension: e?.target?.value })}
                placeholder="1003"
                required />

                <Select
                label="Departman"
                options={departmentOptions}
                value={newUser?.department}
                onChange={(value) => setNewUser({ ...newUser, department: value })} />

              </div>

              <div>
                <h4 className="font-medium text-slate-900 mb-4">Yetkiler</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Checkbox
                  label="Giden Arama Yapabilir"
                  checked={newUser?.permissions?.makeOutboundCalls}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, makeOutboundCalls: e?.target?.checked }
                  })} />

                  <Checkbox
                  label="Gelen Arama Alabilir"
                  checked={newUser?.permissions?.receiveInboundCalls}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, receiveInboundCalls: e?.target?.checked }
                  })} />

                  <Checkbox
                  label="Arama Aktarabilir"
                  checked={newUser?.permissions?.transferCalls}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, transferCalls: e?.target?.checked }
                  })} />

                  <Checkbox
                  label="Raporlara Erişebilir"
                  checked={newUser?.permissions?.accessReports}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, accessReports: e?.target?.checked }
                  })} />

                  <Checkbox
                  label="Kişileri Yönetebilir"
                  checked={newUser?.permissions?.manageContacts}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, manageContacts: e?.target?.checked }
                  })} />

                  <Checkbox
                  label="Arama Kaydedebilir"
                  checked={newUser?.permissions?.recordCalls}
                  onChange={(e) => setNewUser({
                    ...newUser,
                    permissions: { ...newUser?.permissions, recordCalls: e?.target?.checked }
                  })} />

                </div>
              </div>
            </div>

            <div className="p-6 border-t border-slate-200 flex items-center justify-end space-x-4">
              <Button
              variant="outline"
              onClick={() => setShowAddUserModal(false)}>

                İptal
              </Button>
              <Button
              variant="default"
              onClick={handleAddUser}
              iconName="UserPlus"
              iconPosition="left">

                Kullanıcı Ekle
              </Button>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default UserManagementTab;